<template>
  <div class="cpitem_list" v-if="cpList.length > 0">
    <div class="cpitem_list_title">{{title}}</div>
    <div class="cpitem_list_wrap">
      <div class="cpitem_list_wrap_sub">
        <div class="cpitem_list_content" v-for="(item, index) in cpList" :key='index'  @click="handleItem(item,index)">
          <div class="cpitem_list_content_c">
            <div class="cpitem_list_content_c_top">
              <div class="cpitem_list_content_c_top_l">
                <img :src="item.baseInfo.logoImg"/>
                <div class="cpitem_list_content_c_tenantname">{{item.baseInfo.tenantName}}</div>
              </div>
              <div class="cpitem_list_content_c_top_r">
                <img class="cpitem_list_content_c_cehck"  :src="recommendTenantId == item.baseInfo.tenantId || defaultIndex === item.baseInfo.recommend || clickIndex === index? require('../../assets/images/mode_icon_checked.png') : require('../../assets/images/mode_icon_unchecked.png')"/>
              </div>
            </div>
            <div class="cpitem_list_content_c_tags">
              <ul>
                <li v-for="(tag, index) in item.baseInfo.tags" :key="index">{{tag}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 立即加入 -->
      <div class="cpitem_join" @click="handleJoin">立即加入</div>
    </div>
    <!-- 基本要求 -->
      <div class="basic_module" >
        <div class="basic_module_item">
          <div class="basic_module_item_title">
            基本要求
          </div>
          <div class="basic_module_item_content">
            <ul>
              <li>1、年龄：<span>{{ageRule.minAge}}-{{ageRule.maxAge}}周岁</span></li>
              <li><span>2、驾照：</span><span>C1及以上，无一次性记12分的记录，无重大交通事故记录，驾照有效期在90天以上</span></li>
              <li>3、驾龄：<span>C1及以上驾照满3年驾龄</span></li>
              <li>4、身份证：<span>有效期在90天以上</span></li>
              <li>5、信息评审及背景筛查全部通过</li>
              <li>6、申请人同意本平台的全部规则</li>
            </ul>
          </div>
        </div>
        <div class="watch_detail" @click="showModule = true" v-show="!showModule">展开详情<img src="../../assets/images/xiala.png"/></div>
        <!-- 申请流程 -->
        <transition name="sub-comments">
        <div class="basic_module_item" v-show="showModule">
          <div class="basic_module_item_title">
            申请流程
          </div>
          <div class="basic_module_item_content_two">
            <div class="basic_module_item_content_two_item" v-for="(item, index) in moduleData" :key='index'>
              <div class="basic_module_item_content_two_item_circle">{{item.itemIndex}}</div>
              <span>{{item.title}}</span>
              <div :class="index == moduleData.length-1 ? 'basic_module_item_content_two_item_noline' : 'basic_module_item_content_two_item_line'">
                <div class="basic_module_item_content_two_item_subcontent">
                  <ul>
                    <li v-for="(childItem, index) in item.content" :key="index">{{childItem.subContent}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        </transition>
        <div class="close_detail" @click="showModule = false" v-if="showModule">收起详情<img src="../../assets/images/xiala.png"/></div>
      </div>
    <!-- 平台优势 -->
    <div class="plateform">
      <div class="plateform_title">
        平台优势
      </div>
      <div class="plateform_list">
        <ul>
          <li>
            <p>
              <img src="../../assets/images/money.png"/>
            </p>
            <p>收入稳定</p>
          </li>
          <li>
            <p>
              <img src="../../assets/images/project.png"/>
            </p>
            <p>专业培训</p>
          </li>
          <li>
            <p>
              <img src="../../assets/images/safe.png"/>
            </p>
            <p>保险保障</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div v-else-if='cpName == "list" && cpList.length <= 0' class="cpitem_list_nodata">
    <img src="../../assets/images/nodata.png"/>
    <p>当前城市暂未开通代驾平台哦～</p>
  </div>
</template>

<script>
import { reqAgeRule } from '../../apis/serviceApi'
export default {
  props: {
    cpList: { // 租户列表
      type: Array,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    isContinue: {
      type: String,
      default: ''
    },
    cpName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultIndex: null, // 默认选中cp项 默认值
      clickIndex: null,
      recommendTenantId: null, // 默认推荐租户id
      recruitUrl: null,
      // 基本要求模块
      moduleData: [
        {
          itemIndex:1,
          title: '资料提交',
          content: [
            {
              subContent: '根据注册内容指引提交完整有效的身份信息（包含但不限于姓名、身份证件、驾照、证件照片、手机号码等）。'
            }, 
            {
              subContent: '同一司机加入代驾平台数量不可超过2家，首次进入申请页面时已帮您默认推荐1家代驾平台'
            }
          ]
        },
        {
          itemIndex:2,
          title: '资料审核',
          content: [
            {
              subContent: '身份证、驾照、背景筛查、综合评审以及准入审核，具体以注册城市为准'
            }
          ]
        },
        {
          itemIndex:3,
          title: '面试',
          content: [
            {
              subContent: '一对一沟通，了解您的基本信息，具体以注册城市为准'
            }
          ]
        },
        {
          itemIndex:4,
          title: '路考',
          content: [
            {
              subContent: '驾驶技能培训与评估，含坡道起步、侧方停车、倒车入库、曲线驾驶、直角转弯等，具体以注册城市为准'
            }
          ]
        },
        {
          itemIndex:5,
          title: '培训考试',
          content: [
            {
              subContent: '理论知识、服务标准、司机端APP操作等培训与考试，具体以注册城市为准'
            }
          ]
        },
        {
          itemIndex:6,
          title: '领取物料',
          content: [
            {
              subContent: '培训考试结束后统一领取物料或其他补充资料，具体以注册城市为准'
            }
          ]
        },
        {
          itemIndex:7,
          title: '账号激活',
          content: [
            {
              subContent: '下载“单聚多代驾司机端APP”，使用手机号登陆后需打开相关权限、完成钱包充值'
            }
          ]
        },
        {
          itemIndex:8,
          title: '线上考试',
          content: [
            {
              subContent: '登陆司机端APP后，点击『司机课堂』完成“必学任务”并考试通过'
            }
          ]
        }
      ],
      showModule: false, // 是否展示更多详情
      ageRule: {}
    }
  },
  created () {
    // 如果有推荐租户则首先选中推荐租户，若没有推荐租户，则根据recommend 是否等于1进行跳转
    const { recommendTenantId } = this.$route.query
    if (recommendTenantId) {
      this.clickIndex = null
      this.recommendTenantId = recommendTenantId
    } else {
      this.defaultIndex = 1
      this.recommendTenantId = null
    }
    this.getAgeRule()
  },
  methods: {
    getAgeRule () {
      reqAgeRule({}, 7000).then(res => {
        const ruleData = res && res.data
        this.ageRule =  ruleData.driverAge
        console.log(res, '可配置年龄')
      }).catch(err=> {
        console.log(err, '年龄错误信息')
      })
    },
    handleItem(item,index) {
      this.recommendTenantId = null
      this.defaultIndex = null
      this.clickIndex = index
      this.recruitUrl = item.baseInfo.recruitUrl
    },
    handleJoin () {
      const { recommendTenantId } = this.$route.query
      if (this.recruitUrl) {
        window.location.href = this.recruitUrl
        return
      }
      this.cpList.forEach((item, index) => {
        if (recommendTenantId && item.baseInfo.tenantId == recommendTenantId) {
          window.location.href = item.baseInfo.recruitUrl
        } else if (item.baseInfo.recommend == 1) {
          window.location.href = item.baseInfo.recruitUrl
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.cpitem_list_wrap{
  width: 710px;
  margin: 0 auto;
  background: #FFFFFF;
  padding:34px 0px 36px 0px;
  border-radius: 24px;
  margin-bottom: 16px;
  .cpitem_list_wrap_sub{
    background: #f8f8f8;
    border-radius: 16px;
    width: 670px;
    margin: 0 auto;
    padding:40px 0px;
    max-height: 641px;
    overflow-y: scroll;
    margin-bottom: 30px;
  }
}
.cpitem_list{
  margin: 0 auto;
  padding-bottom: 40px;
  .cpitem_list_title{
    margin-top:32px;
    padding-left: 4px;
    margin-bottom: 24px;
    font-size: 36px;
    color: #666666;
    font-weight: bold;
    margin-left: 30px;
  }
  .cpitem_list_content{
    border-radius: 10px;
    display: flex;
    min-height: 160px;
    padding: 0px 24px 0px 26px;
    .cpitem_list_content_c{
      width: 100%;
      .cpitem_list_content_c_top{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .cpitem_list_content_c_top_l{
          display: flex;
          align-items: center;
        }
        img{
          width: 66px;
          height: 66px;
          border-radius: 50%;
        }
        .cpitem_list_content_c_cehck{
          width: 42px;
          height: 42px;
          vertical-align: 4px;
        }
      }
      .cpitem_list_content_c_tenantname{
        font-size: 36px;
        font-weight: bold;
        color: #000000;
        margin-left: 20px;
      }
      .cpitem_list_content_c_reward{
        width: 152px;
        height: 38px;
        background-image: linear-gradient(228deg, #FF8320 0%, #F68C1E 100%, #FF7C26 100%);
        border-radius: 12px 0 12px 0;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        color: #FFFFFF;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .cpitem_list_content_c_tags{
        margin-left: 88px;
        ul{
          display: flex;
          font-size: 26px;
          flex-wrap: wrap;
          color: #47506A;
          font-weight: bold;
          li{
            border: 1px solid #47506A;
            border-radius: 8px;
            padding:6px;
            margin-right: 12px;
            margin-bottom: 12px;
          }
        }
      }
    }
    .last_cpitem_list_content_r{
      margin-top: -28px;
      width: 176px;
      height: 82px;
      line-height: 82px;
      background-image: linear-gradient(270deg, #27A0FF 0%, #176AF0 100%);
      border-radius: 12px;
      font-size: 32px;
      color: #FFFFFF;
      font-weight: bold;
      text-align: center;
    }
    .cpitem_list_content_r{
      display: flex;
      align-items: center;
      align-self: center;
      justify-content: center;
      width: 150px;
      height: 82px;
      background-image: linear-gradient(270deg, #27A0FF 0%, #176AF0 100%);
      border-radius: 12px;
      font-size: 32px;
      color: #FFFFFF;
      font-weight: bold;
    }
  }
}
.cpitem_list_nodata{
  text-align: center;
  margin-top:160px;
  font-size: 32px;
  color: #9F9F9F;
  font-weight: bold;
  img{
    width: 420px;
    height: 360px;
    margin-bottom: 20px;
  }
}
.cpitem_join{
  width: 590px;
  height: 104px;
  background-image: linear-gradient(270deg, #27A0FF 0%, #176AF0 100%);
  border-radius: 52px;
  text-align: center;
  line-height: 104px;
  color: #ffffff;
  font-weight: bold;
  font-size: 36px;
  margin: 0 auto;
}
.basic_module{
  padding:41px 53px 53px 33px;
  width: 710px;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 24px;
  font-size: 30px;
  color: rgba(0,0,0,0.90); 
  line-height: 45px;
  margin-bottom: 16px;
  .basic_module_item_title{
    font-size: 36px;
    margin-bottom: 40px;
  }
  .basic_module_item_title::before{
      content: '';
      display: inline-block;
      width: 6px;
      height: 30px;
      background: #47526d;
  }
  .basic_module_item_content{
    margin-bottom: 30px;
    ul {
      li{
        span{
          color: rgba(0,0,0,0.50); 
        }
      }
      li:nth-of-type(2){
        display: flex;
        span:nth-of-type(1){
          display: inline-flex;
          color: rgba(0,0,0,0.90); 
          width:320px ;
        }
      }
    }
  }
  .watch_detail, .close_detail{
    text-align: center;
    color: #176af0;
    font-size: 30px;
    img{
      width: 40px;
      height: 20px; 
      margin-left: 20px;
      vertical-align: -1px;
    }
  }
  .close_detail {
    img{
      transform: rotate(180deg);
    }
  }
  // 基本要求模块
  .basic_module_item_content_two {
    .basic_module_item_content_two_item {
      .basic_module_item_content_two_item_circle{
        display: inline-flex;
        width: 36px;
        height: 36px;
        background: #176AF0;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 30px;
        margin-right: 19px;
      }
      span{
        color: #176AF0;
        font-size: 30px;
        font-weight: bold;
      }
      .basic_module_item_content_two_item_line{
        border-left: 2px dashed #176AF0;
        margin-left: 18px;
        padding:23px 0px 33px 38px
      }
      .basic_module_item_content_two_item_noline{
         border-left: none !important;
         margin-left: 18px;
         padding:23px 0px 33px 38px
      }
      .basic_module_item_content_two_item_subcontent{
        color: rgba(0,0,0,0.50);
        li::before{
          content: '';
          display: inline-flex;
          width: 8px;
          height: 8px;
          background: #6b7886;
          border-radius: 8px;
          vertical-align: 8px;
          margin-right: 10px;
        }
      }
    }
  }
}
.plateform{
  width: 710px;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 24px;
  padding-bottom: 40px;
  .plateform_title{
    font-size: 36px;
    margin-bottom: 40px;
    padding:40px 44px 0px;
  }
  .plateform_title::before{
    content: '';
    display: inline-block;
    width: 6px;
    height: 30px;
    background: #47526d;
  }
  .plateform_list{
    padding: 0px 58px;
    ul{
      display: flex;
      justify-content: space-between;
    }
    li{
      display: flex;
      flex-direction: column;
      font-size: 30px;
      align-items: center;
      p:first-child{
        width: 100px;
        height: 100px;
        margin-bottom: 10px;
        img{
          width: 100%;
        }
      }
    }
  }
}
.sub-comments-leave-active,.sub-comments-enter-active {
    transition: all 0s linear;
}
.sub-comments-enter,.sub-comments-leave-to {
    height:0 ;
}
</style>